<template>
  <main class="ws">

    <!-- ============ 首屏 ============ -->
    <section class="ph ph--gray">
      <div class="wrap about__hero">
        <div class="about__hero-l">
          <span class="ph__kicker">{{ $t("关于我们") }}</span>
          <h1 class="ph__title">{{ $t("让想把中国货卖出去的人，都能自己开一家跨境店") }}</h1>
          <p class="ph__sub">
            {{ $t("Taoify 是一套跨境电商 SaaS：开店、装修、商品、订单、物流、收款、AI 客服，都在一个后台里管完。") }}
          </p>
          <div class="btns">
            <router-link class="btn btn--primary" to="/sign-up">{{ $t("免费开店") }}</router-link>
            <router-link class="btn btn--line" to="/feature">{{ $t("看功能") }}</router-link>
          </div>
        </div>
        <div class="about__hero-r">
          <div class="mock">
            <div class="mock__bar">
              <span class="mock__dots"><i></i><i></i><i></i></span>
              <span class="mock__url"><i></i>taoify.com/admin</span>
            </div>
            <div class="mock__body mock__body--shot">
              <img class="mock__shot" src="/website/img/admin-dashboard.jpg" :alt="$t('Taoify 商家工作台 · 数据看板界面')" loading="lazy">
            </div>
          </div>
          <img class="about__mascot" src="/website/img/tao-hi.png" alt="">
        </div>
      </div>
    </section>

    <!-- ============ 数据 ============ -->
    <section class="sec sec--tight">
      <div class="wrap">
        <div class="metrics about__metrics">
          <div class="metric"><b>20</b><span>{{ $t("种语言，覆盖全球买家") }}</span></div>
          <div class="metric"><b>3–6%</b><span>{{ $t("阶梯佣金，按成交额自动降") }}</span></div>
          <div class="metric"><b>7×24</b><span>{{ $t("AI 客服在线接待") }}</span></div>
          <div class="metric"><b>1</b><span>{{ $t("个后台管完全流程") }}</span></div>
        </div>
      </div>
    </section>

    <!-- ============ 我们是谁 ============ -->
    <section class="sec sec--gray" id="company">
      <div class="wrap">
        <div class="sec__head">
          <span class="eyebrow">{{ $t("我们是谁") }}</span>
          <h2 class="sec__title">{{ $t("一支做跨境电商系统出身的团队") }}</h2>
          <p class="sec__sub">{{ $t("不是通用建站工具改出来的，是从代购、集运、清关这些真实环节里长出来的系统。") }}</p>
        </div>

        <div class="about__who">
          <div class="about__who-main card">
            <div class="about__brand">
              <img src="/website/img/logo.png" alt="Taoify" class="about__logo">
              <div>
                <b>{{ $t("香港星橋國際貿易有限公司") }}</b>
                <em>{{ $t("跨境行业全链路解决方案软件服务商") }}</em>
              </div>
            </div>
            <p>{{ $t("公司以互联网信息技术开发与物联网 IOT 服务为核心，为跨境卖家提供从建站到履约的整套工具。") }}</p>
            <p>{{ $t("依托自身服务体系与技术团队，我们把店铺系统、商品翻译、跨境物流、收款结算和 AI 客服做成了一条能跑通的链路——卖家不需要自己拼七八个系统。") }}</p>
            <p>{{ $t("产品团队长期和一线卖家、物流商、支付机构一起打磨，形成 Taoify 对跨境场景的理解：能落地的功能，比看起来花哨的功能更重要。") }}</p>
          </div>

          <div class="about__facts">
            <div class="about__fact">
              <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-store"/></svg></span>
              <div>
                <b>{{ $t("店铺与装修") }}</b>
                <em>{{ $t("模板市场 + 可视化装修，装修不用等开发") }}</em>
              </div>
            </div>
            <div class="about__fact">
              <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-globe"/></svg></span>
              <div>
                <b>{{ $t("20 种语言") }}</b>
                <em>{{ $t("商品、政策页、店铺界面一起翻，买家看母语") }}</em>
              </div>
            </div>
            <div class="about__fact">
              <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-truck"/></svg></span>
              <div>
                <b>{{ $t("跨境物流") }}</b>
                <em>{{ $t("面单、轨迹、异常件在一个后台处理") }}</em>
              </div>
            </div>
            <div class="about__fact">
              <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-chat"/></svg></span>
              <div>
                <b>{{ $t("AI 员工与客服") }}</b>
                <em>{{ $t("按你的规则答客户，规则外自动转人工") }}</em>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ 联系 ============ -->
    <section class="sec" id="contact">
      <div class="wrap">
        <div class="sec__head">
          <span class="eyebrow">{{ $t("联系我们") }}</span>
          <h2 class="sec__title">{{ $t("想聊合作、聊方案，直接找人") }}</h2>
          <p class="sec__sub">{{ $t("售前问题可以先问 AI 客服，它答不上会转给同事。") }}</p>
        </div>

        <div class="grid3">
          <article class="card">
            <span class="ico-badge"><svg class="ico"><use href="#i-life"/></svg></span>
            <h3 class="card__t">{{ $t("售前咨询") }}</h3>
            <p class="card__d">{{ $t("工作日 9:00–21:00 有人接，急事直接打电话。") }}</p>
            <a class="frow__link" href="tel:+8615188358607">15188358607<svg class="ico"><use href="#i-arrow"/></svg></a>
          </article>
          <article class="card">
            <span class="ico-badge"><svg class="ico"><use href="#i-mail"/></svg></span>
            <h3 class="card__t">{{ $t("合作与入驻") }}</h3>
            <p class="card__d">{{ $t("渠道合作、代理、企业采购，发邮件说明来意即可。") }}</p>
            <a class="frow__link" href="mailto:liutaotao@taocarts.com">liutaotao@taocarts.com<svg class="ico"><use href="#i-arrow"/></svg></a>
          </article>
          <article class="card">
            <span class="ico-badge"><svg class="ico"><use href="#i-chat"/></svg></span>
            <h3 class="card__t">{{ $t("在线客服") }}</h3>
            <p class="card__d">{{ $t("开店、选品、物流、结算的问题，随时问。") }}</p>
            <a class="frow__link" href="#contact" @click.prevent="askAi">{{ $t("打开对话") }}<svg class="ico"><use href="#i-arrow"/></svg></a>
          </article>
        </div>

        <div class="about__join">
          <div>
            <b>{{ $t("加入我们") }}</b>
            <p>{{ $t("做跨境这件事，我们一直在找懂业务、也愿意把细节做扎实的人。简历发到合作邮箱，标题写清岗位方向。") }}</p>
          </div>
          <div class="about__qr">
            <img src="@/assets/images/recruit/erweima.png" :alt="$t('扫码添加客服')">
            <span>{{ $t("扫码联系我们") }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ CTA ============ -->
    <section class="sec sec--tight" style="padding-top:0">
      <div class="wrap">
        <div class="cta">
          <div>
            <h2 class="cta__t">{{ $t("先开一间店，比自己拼系统快") }}</h2>
            <p class="cta__d">{{ $t("免费试用，不绑卡。跑通一单再决定用哪一档。") }}</p>
          </div>
          <div class="cta__btns">
            <router-link class="btn btn--primary" to="/sign-up">{{ $t("免费开店") }}</router-link>
            <router-link class="btn btn--ghost" to="/pricing">{{ $t("看价格") }}</router-link>
          </div>
        </div>
      </div>
    </section>

  </main>
</template>

<script>
import { openChat } from '@/utils/chat'

export default {
  name: 'AboutUs',
  methods: {
    askAi () {
      openChat('')
    },
  },
}
</script>

<style lang="scss" scoped>
.about__hero {
  display: grid;
  grid-template-columns: 1.05fr .95fr;
  gap: 48px;
  align-items: center;
}

.about__hero-r {
  position: relative;
}

.about__mascot {
  position: absolute;
  right: -14px;
  bottom: -26px;
  width: 108px;
  height: auto;
  filter: drop-shadow(0 10px 22px rgba(24, 20, 60, .16));
}

.about__metrics {
  max-width: 980px;
  margin: 0 auto;
}

.about__who {
  display: grid;
  grid-template-columns: 1.35fr .85fr;
  gap: 28px;
  align-items: start;
}

.about__who-main {
  padding: 30px 32px;
}

.about__who-main p {
  font-size: 14.5px;
  line-height: 1.9;
  color: #4A5762;
  margin-top: 14px;
}

.about__brand {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 18px;
  border-bottom: 1px solid #EFEAF6;
}

.about__logo {
  height: 34px;
  width: auto;
}

.about__brand b {
  display: block;
  font-size: 16.5px;
  color: #1A1626;
  font-weight: 600;
}

.about__brand em {
  font-style: normal;
  font-size: 12.8px;
  color: #8B84A3;
}

.about__facts {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.about__fact {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #EFEAF6;
  border-radius: 14px;
}

.about__fact b {
  display: block;
  font-size: 14px;
  color: #1A1626;
  font-weight: 600;
}

.about__fact em {
  font-style: normal;
  font-size: 12.6px;
  line-height: 1.7;
  color: #6B6580;
}

.about__join {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  margin-top: 28px;
  padding: 24px 28px;
  background: #fff;
  border: 1px solid #EFEAF6;
  border-radius: 16px;
}

.about__join b {
  font-size: 17px;
  color: #1A1626;
  font-weight: 600;
}

.about__join p {
  margin-top: 8px;
  font-size: 13.6px;
  line-height: 1.8;
  color: #6B6580;
  max-width: 620px;
}

.about__qr {
  flex: none;
  text-align: center;
}

.about__qr img {
  width: 96px;
  height: 96px;
  display: block;
  border-radius: 10px;
  border: 1px solid #EFEAF6;
}

.about__qr span {
  display: block;
  margin-top: 6px;
  font-size: 11.6px;
  color: #8B84A3;
}

@media (max-width: 1000px) {
  .about__hero,
  .about__who {
    grid-template-columns: 1fr;
    gap: 26px;
  }
  .about__mascot {
    display: none;
  }
}

@media (max-width: 700px) {
  .about__who-main {
    padding: 22px 20px;
  }
  .about__join {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
}
</style>
